var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutside.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "form",
        {
          ref: "dialogForm",
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onClickNext.apply(null, arguments)
            },
          },
        },
        [
          _c("header", { staticClass: "dialog__header" }, [
            _c(
              "h2",
              { staticClass: "dialog__title", attrs: { id: _vm.titleId } },
              [_vm._v(_vm._s(_vm.$t("proofreadingItemSelectDialog.title")))]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("proofreadingItemSelectDialog.close"),
                  disabled: _vm.isExecuting,
                },
                on: { click: _vm.onClickClose },
              },
              [_vm._v(" × ")]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog__body",
              class: { "dialog__body--disabled": _vm.isExecuting },
            },
            [
              _c("div", { staticClass: "proper-noun-exclude" }, [
                _c("div", { staticClass: "proper-noun-exclude__row" }, [
                  _c(
                    "button",
                    {
                      staticClass: "proper-noun-exclude__toggle",
                      attrs: {
                        type: "button",
                        role: "switch",
                        "aria-checked": _vm.excludeProperNounsEnabled,
                        disabled: _vm.isExecuting,
                      },
                      on: { click: _vm.onToggleExcludeProperNouns },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "switch",
                          attrs: { "data-on": _vm.excludeProperNounsEnabled },
                        },
                        [_c("span", { staticClass: "switch__knob" })]
                      ),
                      _c(
                        "span",
                        { staticClass: "proper-noun-exclude__label" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "proofreadingItemSelectDialog.excludeProperNouns"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "proper-noun-exclude__settings",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t(
                          "proofreadingItemSelectDialog.excludeProperNounsSettings"
                        ),
                        disabled:
                          _vm.isExecuting || !_vm.excludeProperNounsEnabled,
                      },
                      on: { click: _vm.onClickProperNounSettings },
                    },
                    [_c("IconSlider")],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.groupedCategories, function (category) {
                  return _c(
                    "proofreading-category-accordion",
                    {
                      key: category.id,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header-leading",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "category-checkbox",
                                    attrs: {
                                      "data-disabled": _vm.isPremiumCategory(
                                        category
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onToggleCategory(category)
                                      },
                                    },
                                  },
                                  [
                                    _c("CheckboxIcon", {
                                      attrs: {
                                        "is-checked": _vm.isCategoryChecked(
                                          category
                                        ),
                                        fill: _vm.checkboxFill(
                                          _vm.isCategoryChecked(category)
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "category-header-label-row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "category-header-label" },
                                      [_vm._v(_vm._s(category.label))]
                                    ),
                                    _vm.isPremiumCategory(category)
                                      ? _c("PremiumBadgeLink", {
                                          attrs: {
                                            "tooltip-placement": "above",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    _vm._l(category.options, function (option, optionIndex) {
                      return _c(
                        "li",
                        {
                          key: option.id,
                          staticClass: "row row--option",
                          class: _vm.optionRowClass(optionIndex),
                          on: {
                            click: function ($event) {
                              return _vm.onToggleOption(category, option)
                            },
                          },
                        },
                        [
                          _c("CheckboxIcon", {
                            attrs: {
                              "is-checked": _vm.isOptionChecked(option.id),
                              fill: _vm.checkboxFill(
                                _vm.isOptionChecked(option.id)
                              ),
                            },
                          }),
                          _c("span", { staticClass: "label" }, [
                            _vm._v(_vm._s(option.label)),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "info-button",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.$t(
                                  "proofreadingItemSelectDialog.showRuleDescription",
                                  { label: option.label }
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onClickRuleInfo(option)
                                },
                              },
                            },
                            [_c("IconInfo")],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                }),
                1
              ),
            ]
          ),
          _c("footer", { staticClass: "dialog__footer" }, [
            _vm.proceedBlockReason
              ? _c(
                  "p",
                  { staticClass: "dialog__blocker", attrs: { role: "status" } },
                  [_vm._v(" " + _vm._s(_vm.proceedBlockReason) + " ")]
                )
              : _vm._e(),
            _vm.fishEstimateError
              ? _c(
                  "button",
                  {
                    staticClass: "retry-button",
                    attrs: {
                      type: "button",
                      disabled: _vm.isExecuting || _vm.isFishEstimateLoading,
                    },
                    on: { click: _vm.loadFishEstimate },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("proofreadingItemSelectDialog.retry")) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "next-button",
                attrs: {
                  type: "submit",
                  disabled: !_vm.canProceed || _vm.isExecuting,
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isExecuting
                        ? _vm.$t("proofreadingReviseManuscriptPage.loading")
                        : _vm.$t("proofreadingItemSelectDialog.runProofreading")
                    ) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm.isProperNounModalOpen
        ? _c("proper-noun-modal", {
            staticClass: "proper-noun-modal--over-proofreading",
            attrs: { novelId: _vm.novelId },
            on: { close: _vm.onProperNounModalClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }